import {
  Grid as SemanticGrid,
  GridProps as SemanticGridProps,
} from 'semantic-ui-react'
import styled, { css } from 'styled-components'
import Color from 'color'
import { FC } from 'react'

interface GridProps extends SemanticGridProps {
  autoHeight?: boolean
}

const ComposedGrid = styled(({ autoHeight, ...props }) => (
  <SemanticGrid {...props} />
))`
  &&& {
    height: ${props => (props.autoHeight ? 'auto' : '100%')};
  }
`

const Row = styled(({ hoverable, ...props }) => (
  <SemanticGrid.Row {...props} />
))`
  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        background: ${Color('#f5f5f5').darken(0.05).string()};
      }
    `};
`

const Grid: FC<GridProps> & {
  Column: typeof SemanticGrid.Column
  Row: typeof Row
} = (props: GridProps) => <ComposedGrid {...props} />

Grid.Column = SemanticGrid.Column
Grid.Row = Row

export default Grid
